import { Link } from "react-router-dom";

interface CTASectionProps {
  eyebrow?: string;
  subtitle?: string;
  primaryLabel?: string;
  primaryTo?: string;
  primaryHref?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function CTASection({
  eyebrow = "Ready when you are",
  subtitle,
  primaryLabel = "Book Appointment",
  primaryTo = "/book",
  primaryHref,
  secondaryLabel,
  secondaryTo,
}: CTASectionProps) {
  const PrimaryButton = () => {
    if (primaryHref) {
      return (
        <a
          href={primaryHref}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 sm:py-4 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
        >
          {primaryLabel}
          <i className="ri-whatsapp-line transition-transform group-hover:scale-110"></i>
        </a>
      );
    }
    return (
      <Link
        to={primaryTo}
        className="group inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 sm:py-4 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-all hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
      >
        {primaryLabel}
        <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
      </Link>
    );
  };

  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto text-center flex flex-col items-center">
        <div className="inline-flex items-center gap-2 mb-5 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          {eyebrow}
        </div>
        {subtitle && (
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-foreground-600 max-w-xl">
            {subtitle}
          </p>
        )}
        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
          <PrimaryButton />
          {secondaryLabel && secondaryTo && (
            <Link
              to={secondaryTo}
              className="inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-3.5 sm:py-4 rounded-full bg-transparent text-foreground-800 text-sm font-semibold hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
            >
              {secondaryLabel}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}